// removed by extract-text-webpack-plugin
module.exports = {"student-search":"StudentSearch__student-search___1XvfM","student-search-topbar":"StudentSearch__student-search-topbar___3mgdn"};